import { Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { IBaseTable } from 'src/app/interfaces/calibration-set-table.interface';
import { CalibrationSetType, FieldType, getCalibrationSetTypeId } from '../../../../shared/enums';
import * as _ from 'lodash';
import { IBaseTableCell } from 'src/app/interfaces/tables/cells/base-table-cell-interface';
import { ITableSection } from 'src/app/interfaces/calibration-set-table.interface';
import { ViewSettingsService } from 'src/app/core/services/view-settings.service';
import { IFieldSettings } from 'src/app/interfaces/field-settings.interface';

@Component({
    standalone: false,
    selector: 'ziq-horizontal-scroll-table',
    templateUrl: './horizontal-scroll-table.component.html',
    styleUrls: ['./horizontal-scroll-table.component.scss'],
    encapsulation: ViewEncapsulation.None

})
export class HorizontalScrollTableComponent implements OnInit {
    constructor(protected readonly viewSettingsService: ViewSettingsService) {}

    @HostBinding('class')
    readonly hostClass = 'ziq-horizontal-scroll-table';

    @Input()
    currentTab: string;

    @Input()
    table: IBaseTable;

    @Input()
    showRequiredFieldsSwitch: IBaseTable;

    calibrationSetType: CalibrationSetType;

    get columns(): IBaseTableCell<any>[] {
        return this.table.table;
    }

    get sections(): ITableSection[] {
        return this.table.settings.sections;
    }

    fieldType: any = FieldType;

    ngOnInit(): void {
        this.calibrationSetType = getCalibrationSetTypeId(this.currentTab);
    }

    getCellIdentifier(columnIndex, index) {
        return `${columnIndex}-${index}`;
    }

    getSectionIdentifier(index, section: any) {
        return `${section.label}-${index}`;
    }

    getSectionFields(section: ITableSection): IFieldSettings[] {
        return this.showRequiredFieldsSwitch && this.viewSettingsService.showOnlyRequiredFields
            ? section.requiredFields
            : section.fields;
    }

    hasVisibleFields(section: ITableSection): boolean {
        return !!this.getSectionFields(section).length;
    }
}
